module.exports = __webpack_public_path__ + "img/homeBackImg.70aa4b7b.png";